<template>
  <v-btn @click="createNewContextHandler" block height="100" outlined color="grey lighten-1">
    Create New
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex';

import { ref } from '@vue/composition-api';

export default {
  props: {
    folderId: {
      default: false
    }
  },
  setup() {
    const creatingNewContext = ref(false);
    return { creatingNewContext };
  },
  methods: {
    ...mapActions('context', ['createNewContext']),
    async createNewContextHandler() {
      console.log('createNewContext');
      try {
        this.creatingNewContext = true;
        const id = await this.createNewContext({ folderId: this.folderId });
        this.creatingNewContext = false;
        console.log(id);
        this.$router.push({ name: 'context', params: { contextId: id } });
      } catch (e) {
        this.creatingNewContext = false;
        //  probably a toast
        console.log(e);
        //this.creatingContext = false;
      }
    }
  }
};

</script>

<style>

</style>